import React from "react";

import { Box } from "@mui/material";

export const NO_VALUE_TEXT_SX = {
  color: "text.disabled",
  opacity: 0.6,
  fontSize: "0.75rem",
};

// Distinct copy per context: "No reading" for a single value like Signal,
// "No readings" for a timestamp of the last of possibly many.
export function noValueText(label: string) {
  return (
    <Box component="span" sx={NO_VALUE_TEXT_SX}>
      {label}
    </Box>
  );
}
